import SizeBox from 'components/common/SizeBox';
import {
  RESET_VERIFICATION_UPLOAD_DOCUMENTS,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME,
} from 'constants';
import FormInputNameValidation from 'features/pii/components/FormPIIProfilePersonalDetails/components/FormInputNameValidation';
import {
  PII_PROFILE_PERSONAL_DETAILS_FISTNAME_FIELD,
  PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_LASTNAME_FIELD,
  PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME,
  RESET_PII_PROFILE_PERSONAL_DETAILS,
} from 'features/pii/const';
import useProfile from 'features/profile2.0/hooks/useProfile';
import withConfirmCancelFormEditModal from 'features/profileKYC/HOCs/withConfirmCancelFormEditModal';
import useProfileKYC from 'features/profileKYC/hooks/useProfileKYC';
import useProfileKYCStore from 'features/profileKYC/hooks/useProfileKYCStore';
import useHiddenSection from 'hooks/useHiddenOnlyFirst';
import useLang from 'hooks/useLang';
import React, { useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';
import { displayFlexRowCenterSpaceBetweenMixin } from 'styles';
import FormEditItemExpandable from '../FormEditItemExpandable';
import FormEditPersonalDetailsUploadDocuments from '../FormEditPersonalDetailsUploadDocuments';

const FormEditItemExpandableExt = withConfirmCancelFormEditModal(
  FormEditItemExpandable
);

const initialFormField = {
  ...RESET_PII_PROFILE_PERSONAL_DETAILS,
  ...RESET_VERIFICATION_UPLOAD_DOCUMENTS,
};

const INDEX = 0;

const FormEditPersonalDetails = ({
  ref,
  currentEdit,
  setCurrentEdit,
  information,
  setInformation,
  validation,
  setValidation,
  checkFormInputValidation,
  isNextButtonDisabled,
}) => {
  const { t } = useLang();

  const { getFormProfileKYCPersonalDetails, setFormProfileKYCInformation } =
    useProfileKYCStore();
  const formProfileKYCPersonalDetailsStore = getFormProfileKYCPersonalDetails();

  const { checkPersonalDetailsProfileFullNameChange } = useProfileKYC();
  const { getProfileFullName } = useProfile();
  const profileFullName = getProfileFullName();
  const currentProfileFullName = `${information[PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME]} ${information[PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME]}`;
  const profileFullNameStore = `${formProfileKYCPersonalDetailsStore[PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME]} ${formProfileKYCPersonalDetailsStore[PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME]}`;

  const isPersonalDetailsProfileFullNameInformationChange =
    checkPersonalDetailsProfileFullNameChange(
      currentProfileFullName,
      profileFullName
    );
  const isPersonalDetailsProfileFullNameStoreChange =
    checkPersonalDetailsProfileFullNameChange(
      currentProfileFullName,
      profileFullNameStore
    );

  const isShowRestOfUploadDocuments = useHiddenSection({
    isHiddenOnlyFirst: false,
    isShow: isPersonalDetailsProfileFullNameInformationChange,
    deps: [isPersonalDetailsProfileFullNameInformationChange],
  });
  useImperativeHandle(
    ref,
    () => ({
      isShowRestOfUploadDocuments,
    }),
    [isShowRestOfUploadDocuments]
  );

  const isDriverLicenceSelected =
    information[
      VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME
    ];

  const formEditItemExpandableRef = useRef();
  const { setExpand } = formEditItemExpandableRef?.current || {};

  const resetValidation = () => {
    const newValidation = {
      ...validation,
      ...initialFormField,
    };
    setValidation(newValidation);
  };

  const renderRestOfUploadDocuments = () => {
    if (!isShowRestOfUploadDocuments) return null;
    return (
      <>
        <SizeBox height={16} />
        <FormEditPersonalDetailsUploadDocuments
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
      </>
    );
  };

  const handleOnOpenFormEditItemExpandable = () => {
    console.log(
      `⭐ FormEditPersonalDetails 👉 handleOnOpenFormEditItemExpandable ➡️ CLICKED ↩`
    );
    resetValidation();
    setCurrentEdit(INDEX);
  };
  const handleOnCloseFormEditItemExpandable = () => {
    const newInformation = {
      ...formProfileKYCPersonalDetailsStore,
    };
    console.log(
      `⭐ FormEditPersonalDetails 👉 handleOnCloseFormEditItemExpandable ➡️ newInformation ↩`,
      newInformation
    );
    setInformation(newInformation);
    resetValidation();
    setCurrentEdit(-1);
    setExpand(false);
  };
  const handleOnUpdateFormEditItemExpandable = () => {
    let newInformation = { ...information };
    let newValidation = { ...validation };

    console.log(
      `⭐ FormEditPersonalDetails 👉 handleOnUpdateFormEditItemExpandable ➡️ isNextButtonDisabled ↩`,
      isNextButtonDisabled
    );
    if (isNextButtonDisabled) {
      newValidation = checkFormInputValidation(
        newInformation[PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME],
        PII_PROFILE_PERSONAL_DETAILS_FISTNAME_FIELD,
        newInformation,
        newValidation
      );
      newValidation = checkFormInputValidation(
        newInformation[PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME],
        PII_PROFILE_PERSONAL_DETAILS_LASTNAME_FIELD,
        newInformation,
        newValidation
      );
      if (isShowRestOfUploadDocuments) {
        if (isDriverLicenceSelected) {
          newValidation = checkFormInputValidation(
            newInformation[
              VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME
            ],
            VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_FIELD,
            newInformation,
            newValidation
          );
          newValidation = checkFormInputValidation(
            newInformation[
              VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME
            ],
            VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_FIELD,
            newInformation,
            newValidation
          );
        } else {
          newValidation = checkFormInputValidation(
            newInformation[VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME],
            VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_FIELD,
            newInformation,
            newValidation
          );
        }
      }
      console.log(
        `⭐ FormEditPersonalDetails 👉 handleOnUpdateFormEditItemExpandable ➡️ newValidation ↩`,
        newValidation
      );
      setValidation(newValidation);
      return false;
    }
    newInformation = {
      ...newInformation,
      ...(isPersonalDetailsProfileFullNameInformationChange
        ? {}
        : { ...RESET_VERIFICATION_UPLOAD_DOCUMENTS }),
    };
    console.log(
      `⭐ FormEditPersonalDetails 👉 handleOnUpdateFormEditItemExpandable ➡️ newInformation ↩`,
      newInformation
    );
    setInformation(newInformation);
    setFormProfileKYCInformation(newInformation);
    setCurrentEdit(-1);
    return true;
  };

  return (
    <FormEditItemExpandableExt
      ref={formEditItemExpandableRef}
      label={t('form_full_name')}
      value={currentProfileFullName}
      note={t('label_profile_kyc_edit_personal_details_name_note')}
      onOpen={handleOnOpenFormEditItemExpandable}
      onUpdate={handleOnUpdateFormEditItemExpandable}
      isDisabled={currentEdit !== -1 && currentEdit !== INDEX}
      isChange={isPersonalDetailsProfileFullNameStoreChange}
      onCloseFormEditItemExpandable={handleOnCloseFormEditItemExpandable}
    >
      <TwoColSection>
        <FormInputNameValidation
          field={PII_PROFILE_PERSONAL_DETAILS_FISTNAME_FIELD}
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
          checkFormInputValidation={checkFormInputValidation}
          rootStyles={{
            width: 'calc(50% - 6px)',
          }}
        />
        <FormInputNameValidation
          field={PII_PROFILE_PERSONAL_DETAILS_LASTNAME_FIELD}
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
          checkFormInputValidation={checkFormInputValidation}
          rootStyles={{
            width: 'calc(50% - 6px)',
          }}
        />
      </TwoColSection>
      {renderRestOfUploadDocuments()}
    </FormEditItemExpandableExt>
  );
};

const TwoColSection = styled.div`
  ${displayFlexRowCenterSpaceBetweenMixin};
  align-items: start;
`;

export default FormEditPersonalDetails;
